

<template>
  <div class="dialog-modal" v-if="visible">
    <div class="dialog-box">
      <div class="dialog-head">
        <p>{{title}}</p>
        <img
          src="//img1.jianyewy.com/10dd567139556a4a3dea7b9c28559a80.png"
          alt
          class="close-icon"
          @click="modalClick('cancel')"
        >
      </div>
      <div class="dialog-body">
        <div class="reason">
          <p>
            <span>*</span>
            {{title}}：
          </p>
          <textarea placeholder="请输入" v-model="inputContent"></textarea>
        </div>
        <div class="dialog-btn">
          <a href="javascript:;" class="primary" @click="modalClick('submit')">确认</a>
          <a href="javascript:;" class="default" @click="modalClick('cancel')">取消</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* 
  父级组件需要传入visible和title两个属性来控制弹窗的显示和显示标题，、
  组件通过dialogEvent方法将输入框的内容及所点击按钮类型回传给父组件,
*/
export default {
  data() {
    return {
      inputContent: ""
    };
  },
  props: {
    visible: Boolean,
    title: String
  },
  methods: {
    modalClick(type) {
      let content = type == "cancel" ? "" : this.inputContent;
      this.$emit("modalEvent", { inputContent: content, type: type });
      this.inputContent = "";
    }
  }
};
</script>

<style lang="less" module>
.dialog-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background: rgba(53, 64, 82, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;

  .dialog-box {
    width: 500px;
    height: 220px;
    border-radius: 4px;
    background: white;
    box-sizing: border-box;
    position: relative;
    overflow: hidden;
    font-size: 14px;
  }

  .dialog-head {
    font-size: 18px;
    color: #fff;
    height: 40px;
    background: #6f7e95;
    font-size: 14px;
    line-height: 40px;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .close-icon {
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }

  .dialog-body {
    height: 180px;
    overflow: hidden;
    box-sizing: border-box;
    position: relative;

    .reason {
      height: 110px;
      display: flex;
      align-items: top;
      border: 1px solid #ebf1f5;
      padding: 20px;
      justify-content: space-between;
      p {
        padding-top: 7px;
      }
      span {
        color: #e95e90;
      }
      textarea {
        width: 370px;
        height: 70px;
        box-sizing: border-box;
        padding: 10px;
        border: 1px solid #d8dfe5;
        border-radius: 4px;
        font-size: 12px;
        outline: none;
        resize: none;
      }
    }
  }

  .dialog-btn {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    height: 30px;
    position: absolute;
    right: 20px;
    bottom: 20px;

    a {
      height: 30px;
      border-radius: 4px;
      border-style: solid;
      border-width: 1px;
      font-size: 14px;
      width: 100px;
      box-sizing: border-box;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-left: 20px;
    }

    a.primary {
      background: #4f9efa;
      border-color: #4f9efa;
      color: white;
    }

    a.default {
      background: white;
      border-color: #d8dfe5;
      color: #354052;
    }
  }
}
</style>

